import { gql } from '@apollo/client';
import type {
  TemplatePath_PostFragment,
  TemplatePath_TemplateFragment,
} from '../../graphql/generated/graphqlTypes';
import entityPath from './entityPath';

const TEMPLATES_PREVIOUS_ROUTE_KEY = 'templatesPreviousRoute';

export default function templatePath(
  template?: TemplatePath_TemplateFragment | TemplatePath_PostFragment,
) {
  if (template) {
    return `/templates/${entityPath(template.title, template.id)}`;
  }
  return '/templates';
}

export function savePreviousRoute() {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(
      TEMPLATES_PREVIOUS_ROUTE_KEY,
      window.location.pathname,
    );
  }
}

export function getPreviousRoute() {
  return sessionStorage.getItem(TEMPLATES_PREVIOUS_ROUTE_KEY) || '/';
}

templatePath.fragments = {
  template: gql`
    fragment templatePath_template on Template {
      id
      title
    }
  `,
  post: gql`
    fragment templatePath_post on Post {
      id
      title
    }
  `,
};
